import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloSazonalidade } from "../models/sazonalidade";
import { ModeloSopSales } from "../models/sopSales";

import { Repositorio } from "./repositorio";

export class FiltroSopSales {
  editados = false;
  flg_aberto = false;
  num_nivel = 0;

  dth_inicio?: Date | null;
  dth_fim?: Date | null;

  cod_business_unit?: string;
  cod_region?: string;
  cod_product?: string;
  cod_product_family?: string;
  resale = false;


  cod_linha_produto_capitao?: string;
  cod_familia_subgrupo_produto_capitao?: string;
  cod_gerencia?: string;
  cod_acabamento?: string;
  cod_temperatura?: string;
  cod_mercado?: string;
  cod_tipo_produto?: string;
  cod_produto_capitao?: string;

  value?: string = "Quantity";

  des_valor?: number;
  cod_usuario?: number;
  constructor() {
    const today = new Date();
    this.dth_inicio = new Date(today.getFullYear(), today.getMonth() - 12, 1); // 1 ano atrás
    this.dth_fim = new Date(today.getFullYear(), today.getMonth() + 3, 1);    // 3 meses à frente
  }

}

export class RepositorioSopSales extends Repositorio<ModeloSopSales> {
  constructor() {
    super(ConstanteGlobal.SOP_SALES);
  }

  atualizarValor(des_atributo: string, des_valor: string, modelo: ModeloSopSales) {
    return this.api.post(this.nomeRepositorio + "_atualizar_valor", { des_atributo, des_valor, ...modelo }).then((res) => {
      return res.data;
    });
  }

  postSimular(filtro: FiltroSopSales) {
    return this.api.post(this.nomeRepositorio + "_post_simular", filtro).then((res) => {
      return res.data;
    });
  }

  getPrevisao(filtro: FiltroSopSales) {
    return this.api.post(this.nomeRepositorio + "_previsao", filtro).then((res) => {
      return res.data;
    });
  }
  getKpis(filtro: FiltroSopSales) {
    return this.api.post(this.nomeRepositorio + "_kpis", filtro).then((res) => {
      return res.data;
    });
  }

  getQuantity(filtro: FiltroSopSales) {
    return this.api.post(this.nomeRepositorio + "_quantity", filtro).then((res) => {
      return res.data;
    });
  }
  getShareRegion(filtro: FiltroSopSales) {
    return this.api.post(this.nomeRepositorio + "_share_region", filtro).then((res) => {
      return res.data;
    });
  }

  soaSalesLimpaRegistros(filtro: FiltroSopSales) {
    return this.api.post(this.nomeRepositorio + "_limpa_registros", filtro).then((res) => {
      return res.data;
    });
  }

}
